module.exports = __webpack_public_path__ + "static/media/language-my.3dca69ba.svg";